// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__A3_Oy","title":"Header_title__34ePZ","side":"Header_side__DJKK3"};